import React from 'react';
import Squads from '../domains/squads/components/Squads';

const SquadsPage: React.FC = () => {
  return <Squads />;
};

export default SquadsPage; 